import React, { useEffect } from "react";
import { useFetchMaterialsData } from "../../hooks/useFetchMaterialsData";
import MaterialsTable from "../MaterialsTable";
import { Dialog, DialogContent } from "@material-ui/core";
import Label from "../Label";
import Loading from "../Loading";
import { ContainerBox } from "./styles";
import usePersonData from "../../hooks/usePersonData";

const AssociateModal = ({ participant, onClose, open }) => {
    const { data, error, loading, refetch } = useFetchMaterialsData();
    const { fetchPersonById, person, setPerson } = usePersonData();

    const fetchItems = async () => {
        await refetch();
    };

    const getItems = () => data;

    useEffect(() => {
        if (open && participant?.id && participant.id !== person?.id) {
            fetchPersonById(participant.id).then((updatedPerson) => {
                if (updatedPerson) {
                    setPerson(updatedPerson);
                }
            });
        }
    }, [open, participant?.id, person?.id, fetchPersonById, setPerson]);

    return (
        <Dialog fullWidth maxWidth="lg" onClose={onClose} open={open}>
            {loading && <Loading />}
            {error && <div>{error}</div>}
            <ContainerBox className="content">
                <DialogContent
                    style={{
                        minWidth: "400px",
                        maxWidth: "calc(100vw - 32px)",
                        maxHeight: "calc(100vh - 32px)",
                        overflow: "auto",
                        padding: "16px",
                    }}
                >
                    <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                        Associar Itens a {participant.name}
                    </Label>

                    <MaterialsTable
                        items={data}
                        person={person}
                        associatedItems={person?.personMaterials || []}
                        onClose={onClose}
                        refetchItems={fetchItems}
                        getUpdatedItems={getItems}
                    />
                </DialogContent>
            </ContainerBox>
        </Dialog>
    );
};

export default AssociateModal;
